import React, { useContext } from "react";
import { Container } from "react-bootstrap";
import "./style.scss";
import Accordion from "react-bootstrap/Accordion";
import AccordionContext from "react-bootstrap/AccordionContext";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";

const Toggle = ({ eventKey, callback }) => {
  const activeEventKey = useContext(AccordionContext);
  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey)
  );
  const isCurrentEventKey = activeEventKey === eventKey;
  return (
    <div className="toggle-icon" onClick={decoratedOnClick}>
      {isCurrentEventKey ? (
        <AiOutlineMinus size={30} />
      ) : (
        <AiOutlinePlus size={30} />
      )}
    </div>
  );
};
const FaqItem = ({ title, content, id }) => {
  return (
    <div className="faq__item">
      <Accordion>
        <div className="toggle-area">
          <p>{title}</p>
          <Toggle eventKey={id} />
        </div>
        <Accordion.Collapse eventKey={id}>
          <div>{content}</div>
        </Accordion.Collapse>
      </Accordion>
    </div>
  );
};
const Faq = ({ faqs }) => {
  return (
    <div className="faq__section">
      <Container>
        <h1 className="title">FAQ</h1>
        <div className="faq_list">
          {faqs && faqs.map((item) => <FaqItem key={item.id} {...item} />)}
        </div>
        <p className="need_help">
          Need help? Feel free to reach out to our team to walk you through the
          process and answer any questions you might have.
        </p>
        <a href="#/" className="reach">
          Reach out to our team →
        </a>
      </Container>
    </div>
  );
};
Faq.defaultProps = {
  faqs: [
    {
      id: 1,
      title: "How do you value my business?",
      content: "This is a dummy content",
    },
    {
      id: 2,
      title: "How do you use the data I provide?",
      content: "This is a dummy content",
    },
    {
      id: 3,
      title: "How long does the process take?",
      content: "This is a dummy content",
    },
    {
      id: 4,
      title: "Am I committing to anything?",
      content: "This is a dummy content",
    },
  ],
};
export default Faq;
